
import { Component, Vue, Watch } from "vue-property-decorator";
import { ScanforBubblePackageModule } from "@/store/modules/store_scanforbubblepackage";
import { queryLockWeight } from "@/api/service";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "Form1",
})
export default class extends Vue {
  public checkbox_LockLengthWidthHeightShow = false;
  public globalConfig: any = {};
  public timer;
  public lockState = false;
  @Watch("checkbox_LockLengthWidthHeight", { deep: true })
  onChildChanged(val: boolean) {
    this.lockState = val;
  }
  mounted() {
    this.globalConfig = SystemConfigModule.globalData;
    if (this.globalConfig.CurrentDeviceType == 4) {
      this.timer = null;
      this.timer = setInterval(() => {
        if (this.GetQueryLockWeight()) {
          //返回000 表示可以进行重量锁定
          this.checkbox_LockLengthWidthHeightShow = true;
        } else {
          this.checkbox_LockLengthWidthHeightShow = false;
          this.checkbox_LockLengthWidthHeight = false;
          this.lockState = false;
        }
      }, 3600000); //定时1个小时检查一次

      if (this.GetQueryLockWeight()) {
        // if (true) {//测试用
        //返回000 表示可以进行重量锁定
        this.checkbox_LockLengthWidthHeightShow = true;
      }
    }
  }
  public lockFunc(checked) {
    if (checked) {
      console.log(checked);
      debugger;
      if (
        ScanforBubblePackageModule.sizeX == 0 ||
        ScanforBubblePackageModule.sizeY == 0 ||
        ScanforBubblePackageModule.sizeZ == 0
      ) {
        debugger;
        this.$nextTick(() => {
          this.checkbox_LockLengthWidthHeight = false;
        });
        ScanforBubblePackageModule.setErrorMessage("长宽高不能为0");

        return;
      }
      // if (
      //   ScanforBubblePackageModule.sizeX > 500 ||
      //   ScanforBubblePackageModule.sizeY > 500 ||
      //   ScanforBubblePackageModule.sizeZ > 500
      // ) {
      //   this.$nextTick(() => {
      //     this.checkbox_LockLengthWidthHeight = false;
      //     ScanforBubblePackageModule.setErrorMessage(
      //       "长宽高数值超过500CM，数值过大，请重新输入"
      //     );
      //   });
      //   return;
      // }
      ScanforBubblePackageModule.setErrorMessage("");
    }
  }
  public GetQueryLockWeight() {
    try {
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "",
        body: {
          queryValue: this.globalConfig.CompName,
          queryType: "34",
          viewType: "",
          extend1: "",
          extend2: "",
          extend3: "",
        },
      };
      let response = JSON.parse(queryLockWeight(JSON.stringify(request)));
      if (
        response != null &&
        response != undefined &&
        response.respcode == "000"
      ) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }
  get input_SizeX() {
    return ScanforBubblePackageModule.sizeX;
  }
  set input_SizeX(num) {
    if (num.toString() == "") {
      num = 0;
    }
    ScanforBubblePackageModule.setSizeX(num);
  }
  get input_SizeY() {
    return ScanforBubblePackageModule.sizeY;
  }
  set input_SizeY(num) {
    if (num.toString() == "") {
      num = 0;
    }
    ScanforBubblePackageModule.setSizeY(num);
  }
  get checkbox_LockLengthWidthHeight() {
    return ScanforBubblePackageModule.lockLengthWidthHeight;
  }
  set checkbox_LockLengthWidthHeight(lockResult) {
    ScanforBubblePackageModule.setLockLengthWidthHeight(lockResult);
  }
  get input_SizeZ() {
    return ScanforBubblePackageModule.sizeZ;
  }
  set input_SizeZ(num) {
    if (num.toString() == "") {
      num = 0;
    }
    ScanforBubblePackageModule.setSizeZ(num);
  }

  private EndInput() {
    debugger;
    try {
      this.input_SizeX = parseFloat(this.input_SizeX.toString());
      if (this.input_SizeX != this.input_SizeX) {
        this.input_SizeX = 0;
      }
    } catch (error) {
      this.input_SizeX = 0;
      return;
    }
    try {
      this.input_SizeY = parseFloat(this.input_SizeY.toString());
      if (this.input_SizeY != this.input_SizeY) {
        this.input_SizeY = 0;
      }
    } catch (error) {
      this.input_SizeY = 0;
      return;
    }
    try {
      this.input_SizeZ = parseFloat(this.input_SizeZ.toString());
      if (this.input_SizeZ != this.input_SizeZ) {
        this.input_SizeZ = 0;
      }
    } catch (error) {
      this.input_SizeZ = 0;
      return;
    }
    let warning =
      this.input_SizeX > 500 ||
      this.input_SizeY > 500 ||
      this.input_SizeZ > 500;
    if (warning) {
      ScanforBubblePackageModule.setErrorMessage(
        "长宽高数值超过500CM，数值过大，请重新输入"
      );
    }

    ScanforBubblePackageModule.setSizeX(
      this.input_SizeX > 500 ? 0 : this.input_SizeX
    );
    ScanforBubblePackageModule.setSizeY(
      this.input_SizeY > 500 ? 0 : this.input_SizeY
    );
    ScanforBubblePackageModule.setSizeZ(
      this.input_SizeZ > 500 ? 0 : this.input_SizeZ
    );
    if (
      this.input_SizeX + this.input_SizeY + this.input_SizeZ > 90 ||
      this.input_SizeX > 40 ||
      this.input_SizeY > 40 ||
      this.input_SizeZ > 40
    ) {
      debugger;
      let aaa = (
        (this.input_SizeX * this.input_SizeY * this.input_SizeZ) /
        10000
      ).toFixed(2);

      ScanforBubblePackageModule.setDimensionalWeight(aaa);
    } else {
      ScanforBubblePackageModule.setDimensionalWeight(0);
    }
  }
  get input_DimensionalWeight() {
    return ScanforBubblePackageModule.dimensionalWeight;
  }
  set input_DimensionalWeight(num) {
    ScanforBubblePackageModule.setDimensionalWeight(num);
  }
  get input_Id() {
    return ScanforBubblePackageModule.id;
  }
  set input_Id(str) {
    ScanforBubblePackageModule.setId(str);
  }
}
